<template lang="pug">
article(
    :class="styles.root"
)
    img(
        :class="styles.logo"
        src="/images/common/elqr-logo.svg"
        alt="elqr logo"
        height="28"
        width="auto"
    )
    p(
        :class="styles.title"
    ) Отсканируйте QR-код в любом банковском приложении или  эл. кошельке Кыргызстана
    div(
        :class="styles['qr-wrapper']"
    )
        Qr(
            :class="styles.qr"
            :text="state.url"
            is-logo
        )
        img(
            :class="styles['logo-namba']"
            src="/images/common/namba-logo-square.svg"
            alt="namba logo"
            height="64"
            width="64"
        )
    p(
        :class="styles.merchant"
    ) {{ state.merchant?.name || state.merchant?.slugId || '+996 655 655 555' }}
</template>

<script lang="ts">
import Vue, { useCssModule } from 'vue'

import { Qr } from '@/shared/ui/Qr'
import { ImageSvg } from '@/shared/ui/ImageSvg'
import { useAppStore } from '@/shared/model'

export default Vue.extend({
    name: 'QrForDownload',
    components: { Qr, ImageSvg },
    setup() {
        const styles = useCssModule()
        const { state } = useAppStore()

        return {
            styles,
            state,
        }
    },
})
</script>

<style module lang="scss" src="./QrForDownload.module.scss" />
